module.exports = __webpack_public_path__ + "img/gift_box.fc60554b.svg";